import * as z from "zod/v4";

export const getOmsAutoMergeSavings = {
  name: "getOmsAutoMergeSavings" as const,
  input: z.object({}),
  output: z
    .object({
      estimatedSavingsCents: z.number(),
      mergeableOrders: z.number(),
      totalOrders: z.number(),
      daysBack: z.number(),
    })
    .nullable(),
};
